export default {
    SET_LANG(state, lang) {
        if (!state.settings) {
            state.settings = {
                lang: lang
            };
            return;
        }

        state.settings.lang = lang;
    },

    SET_USER(state, data) {
        state.user = {
            data: data
        };
    },

    SET_USER_LOGIN(state, data) {
        state.userLogin = data;
    },

    SET_SELECTED_COMPANY(state, data) {
        state.selectedCompany = data;
    },

    // SET_ID_TOKEN(state, token) {
    //     state.user.idToken = token;
    // },

    SET_USER_EMAIL(state, email) {
        state.user.data.email = email;
    },

    SET_SHOW_MENU(state, showMenu) {
        state.showMenu = showMenu;
    }
};